import React from "react";

import { useDispatch, useSelector } from "@src/store";
import {
  ExperienceBuilderAiAction,
  ExperienceBuilderAiSelector,
} from "@src/store/slices/experienceBuilder/ai";

import { ChoiceSheet } from "./ChoiceSheet";

/**
 * Viv wiring for the navigation picker. Renders the generic ChoiceSheet from
 * the pending `navigationChoice` and feeds the user's pick/cancel back as the
 * resolution the `navigate` side-effect handler is awaiting — which then drives
 * the (single) continuation. Mount inside the `body` slot's relative container.
 */
export const NavigationChoiceSheet = () => {
  const dispatch = useDispatch();
  const choice = useSelector(ExperienceBuilderAiSelector.getNavigationChoice);

  // Slide out the moment a resolution lands; the handler clears the choice
  // once it has built its continuation.
  const open = Boolean(choice && !choice.resolution);

  return (
    <ChoiceSheet
      open={open}
      title="Which page did you mean?"
      options={choice?.options ?? []}
      onSelect={(option) =>
        dispatch(ExperienceBuilderAiAction.navigationChoiceMade(option))
      }
      onCancel={() =>
        dispatch(ExperienceBuilderAiAction.navigationChoiceCancelled())
      }
    />
  );
};
